import { NavigationClient, NavigationOptions } from "@azure/msal-browser";
import { NavigateFunction } from "react-router-dom";

/**
 * Custom navigation client for MSAL to integrate with React Router
 * This allows MSAL to use React Router's navigation instead of window.location
 */
export class CustomNavigationClient extends NavigationClient {
    private navigate: NavigateFunction;

    constructor(navigate: NavigateFunction) {
        super();
        this.navigate = navigate;
    }

    /**
     * Navigates to other pages within the same web application
     * @param url - URL to navigate to
     * @param options - Navigation options
     */
    async navigateInternal(url: string, options: NavigationOptions): Promise<boolean> {
        const relativePath = url.replace(window.location.origin, "");
        
        if (options.noHistory) {
            this.navigate(relativePath, { replace: true });
        } else {
            this.navigate(relativePath);
        }

        return false; // Return false to prevent MSAL from doing its own navigation
    }
}